import React, { useEffect, useState } from 'react';
import { FaHeadset, FaTrash, FaTicketAlt, FaEdit, FaTimes, FaCheck, FaEnvelope } from 'react-icons/fa';

const SupportModuleCard = ({ supportModule, onDelete, onNotificationEmailUpdate }) => {
  const [editingEmail, setEditingEmail] = useState(false);
  const [email, setEmail] = useState(supportModule.settings?.notificationEmail || '');
  const [savingEmail, setSavingEmail] = useState(false);
  const [emailError, setEmailError] = useState('');
  useEffect(() => setEmail(supportModule.settings?.notificationEmail || ''), [supportModule.settings?.notificationEmail]);
  const saveEmail = async event => {
    event.preventDefault();
    setEmailError('');
    setSavingEmail(true);
    try {
      await onNotificationEmailUpdate(supportModule._id, email.trim());
      setEditingEmail(false);
    } catch (error) {
      setEmailError(error.message);
    } finally {
      setSavingEmail(false);
    }
  };
  const getStatusColor = (isActive) => {
    return isActive ? 'text-green-400' : 'text-red-400';
  };

  const getStatusText = (isActive) => {
    return isActive ? 'Active' : 'Inactive';
  };


  return (
    <div className="group relative overflow-hidden rounded-2xl bg-black p-6 border border-gray-800 hover:border-gray-700 transition-all duration-300 hover:shadow-xl">
      {/* Module Icon */}
      <div className="flex items-center mb-4">
        <div className="h-12 w-12 bg-gray-800 rounded-xl flex items-center justify-center relative">
          <FaHeadset className="h-6 w-6 text-gray-300" />
          {/* Status Indicator - Top Right of Icon */}
          <div className={`absolute -top-1 -right-1 w-3 h-3 rounded-full border-2 border-gray-800 ${supportModule.isActive ? 'bg-green-400' : 'bg-red-400'}`}></div>
        </div>
        <div className="ml-4 flex-1">
          <h3 className="text-lg font-semibold text-white group-hover:text-gray-300 transition-colors text-left">
            {supportModule.name}
          </h3>
          <button
            onClick={() => window.open(`/dashboard/projects/${supportModule.projectId?._id}`, '_blank')}
            className="text-sm text-gray-400 hover:text-gray-300 transition-colors text-left block w-full"
          >
            {supportModule.projectId?.name || 'Unknown Project'}
          </button>
        </div>
      </div>

      {/* Description */}
      {supportModule.description && (
        <p className="text-gray-300 text-sm mb-4 line-clamp-2">
          {supportModule.description}
        </p>
      )}


      {/* Per-module notification recipient */}
      <div className="rounded-lg border border-gray-800 bg-gray-900/50 p-4 mb-4 text-left">
        <div className="flex items-center justify-between gap-2 mb-2">
          <span className="flex items-center gap-2 text-xs text-gray-400"><FaEnvelope /> Notification email</span>
          {!editingEmail && <button type="button" onClick={() => setEditingEmail(true)} className="inline-flex items-center gap-1 text-xs text-indigo-300 hover:text-white" aria-label={`Edit notification email for ${supportModule.name}`}><FaEdit /> Edit</button>}
        </div>
        {editingEmail ? (
          <form onSubmit={saveEmail}>
            <input autoFocus type="email" required value={email} onChange={event => setEmail(event.target.value)} aria-label={`Notification email for ${supportModule.name}`} className="w-full rounded-lg border border-gray-700 bg-gray-800 px-3 py-2 text-sm text-white placeholder-gray-500 focus:border-indigo-500 focus:outline-none" placeholder="name@example.com" />
            {emailError && <p role="alert" className="mt-2 text-xs text-red-400">{emailError}</p>}
            <div className="mt-3 flex justify-end gap-2">
              <button type="button" disabled={savingEmail} onClick={() => { setEmail(supportModule.settings?.notificationEmail || ''); setEmailError(''); setEditingEmail(false); }} className="inline-flex items-center gap-1 rounded-lg px-3 py-1.5 text-xs text-gray-300 hover:bg-gray-800"><FaTimes /> Cancel</button>
              <button type="submit" disabled={savingEmail || !email.trim()} className="inline-flex items-center gap-1 rounded-lg bg-indigo-600 px-3 py-1.5 text-xs text-white hover:bg-indigo-500 disabled:opacity-50"><FaCheck /> {savingEmail ? 'Saving…' : 'Save'}</button>
            </div>
          </form>
        ) : <p className="break-all text-sm text-white">{email || 'No notification email set'}</p>}
      </div>

      {/* Statistics */}
      <div className="bg-gray-900/50 rounded-lg p-4 mb-4">
        <div className="flex items-center justify-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-gray-800 rounded-lg">
            <FaTicketAlt className="h-5 w-5 text-gray-300" />
          </div>
          <div className="text-left">
            <p className="text-xs text-gray-400 mb-1">Total Tickets</p>
            <p className="text-xl font-bold text-white">
              {supportModule.statistics?.totalTickets || 0}
            </p>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="flex items-center justify-between pt-4 border-t border-gray-800">
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onDelete(supportModule)}
            className="p-2 text-gray-400 hover:text-red-400 hover:bg-gray-800 rounded-lg transition-colors"
            title="Delete Module"
          >
            <FaTrash className="h-4 w-4" />
          </button>
        </div>
        
        <div className="text-xs text-gray-500">
          Created {new Date(supportModule.createdAt).toLocaleDateString()}
        </div>
      </div>
    </div>
  );
};

export default SupportModuleCard;
